import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";
// import store from '../../store';
import { SRLWrapper } from "simple-react-lightbox";
import images from '../../assets/images/images';
// Custom components
import AppHeader from '../../components/AppHeader';
import { DefaultButton } from '../../components/Buttons';
import { PrivacyPolicy, Copyright } from '../../components/Links';
// Material components
import { Grid, Container } from '@material-ui/core';
// Styles
import './styles.css'
import { makeStyles } from '@material-ui/core/styles';
import { flex, link, fonts } from '../../assets/jss';
import allFonts from '../../assets/css/fonts';
const container = {
    width: '100%',
    ...flex.flex_row_center,
    paddingBottom: 0,
}
const useStyles = makeStyles((theme) => ({
    headerContainer: {
        ...container,
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 0,
        }
    },
    headerText: {
        ...flex.flex_column_center,
        textAlign: 'center',
        marginTop: 100,
        padding: '0px 100px 50px 100px',
        [theme.breakpoints.down('sm')]: {
            marginTop: 30,
            padding: '0px 20px 30px 20px'
        }
    },
    headerImage: {
        position: 'relative',
        width: '100%'
    },
    featuresContainer: {
        ...container,
        backgroundColor: 'white',
        color: 'black',
        paddingBottom: 30,
        [theme.breakpoints.down('sm')]: {
            margin: 12,
        }
    },
    featureText: {
        ...flex.flex_column_center,
        textAlign: 'center',
        justifyContent: 'space-around',
        padding: '100px 30px',
        [theme.breakpoints.down('md')]: {
            padding: '100px 30px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '50px 30px',
        }
    },
    galleryWrapper: {
        marginBottom: 20,
        paddingTop: 50
    },
    imageGalleryItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px'
    },
    galleryImage: {
        width: '100%',
    },
    footer: {
        backgroundColor: 'white',
        color: 'black',
        height: '5vh',
        ...flex.flex_row_around,
        alignItems: 'center',
        flexWrap: 'wrap'
    },
    contributeDiv: {
        ...flex.flex_column_center,
        marginBottom: 50
    },
    welcome: {
        margin: 5,
        // fontFamily: 'ArchitectsDaughter',
        fontSize: '2.8rem'
    },
    title: {
        fontFamily: 'Piedra',
        fontSize: '5rem',
        [theme.breakpoints.down('md')]: {
            fontSize: '3.5rem',
        }
    },
    titleSub: {
        fontFamily: 'PatrickHand',
        fontSize: '1.5rem',
        margin: '12px 0px'
    },
    howItWorks: {
        margin: 5,
        fontFamily: 'ArchitectsDaughter',
        fontSize: '2.8rem'
    },
    theGoal: {
        fontSize: '1rem',
        padding: '0px 20px',
        fontFamily: 'PatrickHand',
    },
    theOriginals: {
        fontSize: '2.8rem',
        fontFamily: 'Tangerine',
        margin: `0px 12px 30px 12px`
    }
}));

function Landing() {
    const classes = useStyles();
    const [count, setCount] = useState(0);
    // const [fontInterval, setFontInterval] = useState()
    let arr = Object.values(allFonts);
    let fontArray = arr.filter(font => font !== 'PressStart2P')

    useEffect(() => {
        let fontInterval = setInterval(() => {
            setCount(count => count + 1)
        }, 1000)

        return (() => {
            clearInterval(fontInterval);
        })
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (count > fontArray.length) {
            setCount(0)
            return;
        }
        //eslint-disable-next-line
    }, [count])

    return (
        <AppHeader>
            <Grid container className={classes.headerContainer}>
                <Grid item xs={12} sm={6}
                    className={classes.headerText}>
                    <h3 style={{ fontFamily: fontArray[count] }} className={classes.welcome}>Welcome to </h3>
                    <h2 className={classes.title}>5 Words Stories</h2>
                    <span className={classes.titleSub}>An experiment in restrictive, </span>
                    <span className={classes.titleSub}>collaborative writing.</span>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <img src={images[0].src} alt='earthfest'
                        className={classes.headerImage} />
                </Grid>
            </Grid>

            <Grid container className={classes.featuresContainer}>
                <Grid item xs={12} sm={6}>
                    <img src={images[1].src} alt='earthfest'
                        className={classes.headerImage} />
                </Grid>

                <Grid item xs={12} sm={6}
                    className={classes.featureText}>
                    <h2 className={classes.howItWorks}>How it works...</h2>
                    <div>
                        <h4 className={classes.titleSub}>
                            The story starts with 5 words.
                        </h4>
                        <h4 className={classes.titleSub}>
                            Another author contributes 5 more words.
                        </h4>
                        <h4 className={classes.titleSub}>
                            Wait till 5 other people contributed.
                        </h4>
                    </div>
                    <h6 className={classes.theGoal}>
                        The goal is to create a continues flow of ideas that leads to a semi-coherent
                        story. The greatest challenge, is to get people to contribute words that evolve the
                        story and not simply try and use their 5 words to write something mind-blowing.
                        This often seems out of place and breaks the flow.
                    </h6>
                    <Link style={{ ...link }} to='/recentStories'>
                        <DefaultButton variant="dark">
                            View / contribute to online stories
                        </DefaultButton>
                    </Link>
                </Grid>
            </Grid>

            <Container className={classes.galleryWrapper}>
                <h2 className={classes.theOriginals}>The Original 5 words stories</h2>
                <Container style={{ marginBottom: 50 }}>
                    <SRLWrapper>
                        <Grid container className={classes.imageGallery}>
                            {images.map(image =>
                                <Grid key={image.src} item xs={6} sm={3} className={classes.imageGalleryItem}>
                                    <img src={image.src} alt={image.alt} className={classes.galleryImage} />
                                </Grid>
                            )}
                        </Grid>
                    </SRLWrapper>
                </Container>
                <Container className={classes.contributeDiv}>
                    <Link style={{ ...link }} to='/gallery'>
                        <DefaultButton variant="light">
                            View More
                        </DefaultButton>
                    </Link>
                    <br />

                </Container>
            </Container>

            <Container maxWidth='xl' className={classes.footer}>
                <PrivacyPolicy />
                <Copyright />
            </Container>

            <CookieConsent
                location="bottom"
                buttonText="I accept"
                cookieName="myAwesomeCookieName2"
                style={{ background: "#2B373B" }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                expires={150}
                enableDeclineButton
                onDecline={() => {
                    alert("No thanks!");
                }}
            >
                <span style={fonts.default}>This website uses cookies to enhance the user experience.</span>
            </CookieConsent>
        </AppHeader>

    );
}

export default Landing;
